export default __webpack_public_path__ + "static/media/filters.6bd80c71.svg";